import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PbiManagerMfeRoutingModule } from './pbi-manager-mfe-routing.module';
import { PbiManagerMfeComponent } from './pbi-manager-mfe/pbi-manager-mfe.component';

@NgModule({
  declarations: [PbiManagerMfeComponent],
  imports: [
    CommonModule,
    PbiManagerMfeRoutingModule
  ]
})
export class PbiManagerMfeModule { }
